import { PageComponent } from "barba"

class DiscoverBikes {

    constructor({ node }) {
        this.node = node
        this.image = this.node.querySelector('.discover-bikes__image')
        this.links = this.node.querySelectorAll('.discover-bikes__link[data-image-url]')
        this.template = this.node.querySelector('template')
        
        this.changeHandler = this.change.bind(this)

        this.links.forEach(x => {
            x.addEventListener('mouseenter', this.changeHandler)
            x.addEventListener('focusin', this.changeHandler)
        })

        if (this.links && this.links[0]) {
            this.replace(this.links[0].dataset.imageUrl)
        }
        
    }

    change(e) {
        this.replace(e.target.dataset.imageUrl)
    }

    replace(url) {
        const key = "%URL%"
        const picture = this.image.querySelector('.discover-bikes__pic')

        if (picture && picture.dataset.imageUrl === url) {
            return
        }

        if (picture) {
            this.image.removeChild(picture)
        }

        if (!url) {
            return
        }

        let newPicture = document.importNode(this.template.content, true)
        
        newPicture.querySelectorAll('[data-image-url]').forEach(x => x.dataset.imageUrl = x.dataset.imageUrl.replace(key, url))
        newPicture.querySelectorAll('[srcset]').forEach(x => x.srcset = x.srcset.replace(key, url))
        newPicture.querySelectorAll('[src]').forEach(x => x.src = x.src.replace(key, url))

        this.image.append(newPicture)
        newPicture = null
    }

    destroy() {
        this.links.forEach(x => {
            x.removeEventListener('mouseenter', this.changeHandler)
            x.removeEventListener('focusin', this.changeHandler)
        })

        delete this.node
        delete this.image
        delete this.links
        delete this.template

        delete this.changeHandler
    }

}

new PageComponent(".discover-bikes", DiscoverBikes)